//转换时间
const formatTime = (t, type) => {
  // 2019/9/1 上午12:00:00
  return (type == "int" ? t.getTime() / 1000 : (t.getTime() / 1000).toString())
}
const addZero = (a) => {
  return a < 10 ? "0" + a : a;
}
const formatDate = (now) => {
  var now = new Date(now * 1000);
  var year = now.getFullYear();
  var month = addZero(now.getMonth() + 1);
  var date = addZero(now.getDate());
  var hour = addZero(now.getHours());
  var minute = addZero(now.getMinutes());
  var second = addZero(now.getSeconds());
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}
// 输出年-月-日
const formatDate_ymd = (now) => {
  var now = new Date(now);
  var year = now.getFullYear();
  var month = addZero(now.getMonth() + 1);
  var date = addZero(now.getDate());
  return year + "-" + month + "-" + date
}
// 切除后台返回的时间
const formatB2F = (res) => {
  return res.split(' ')[0].split('.').join('-')
}
// 计划：
// 防抖
// 节流
// 数字格式化
// 深度克隆
// 浅克隆
// 处理异步
const sto = (callback, time) => {
  let st = setTimeout(() => {
    callback.bind(vm)
    clearTimeout(st)
  }, time);
}
const o2a= (obj) => {
  let aa = [];
  for (let k in obj) {
    let oo = {
      name: obj[k],
      id: k
    };
    aa.push(oo);
  }
  return aa;
}

const o2ap = (obj) => {
  let aa = [];
  for (let k in obj) {
    let oo = {
      name: obj[k],
      id: parseInt(k)
    };
    aa.push(oo);
  }
  return aa;
}

export default {
  formatTime,
  formatDate,
  sto,
  formatDate_ymd,
  formatB2F,
  o2a,
  o2ap
}



// WEBPACK FOOTER //
// ./src/assets/lib/js/util.js